import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-[#27272A] bg-brand">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <h3 className="font-cabinet font-black uppercase text-5xl md:text-7xl tracking-tighter leading-[0.85] text-white">
              Jaxson Dinmore
            </h3>
            <a
              href="mailto:jdwebsites1@gmail.com"
              data-testid="footer-email"
              className="font-satoshi font-bold text-xl text-white/80 hover:text-white transition-colors mt-4 inline-block underline underline-offset-4"
            >
              jdwebsites1@gmail.com
            </a>
          </div>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
            data-testid="footer-cta"
            className="font-satoshi font-bold text-sm uppercase tracking-widest px-8 py-4 bg-white text-[#09090B] hover:bg-[#09090B] hover:text-white transition-colors duration-200 self-start"
          >
            {t.footer.start}
          </a>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4 mt-16 pt-8 border-t border-white/20 font-satoshi font-bold text-xs text-white/70 uppercase tracking-widest">
          <span>© {new Date().getFullYear()} Jaxson Dinmore — {t.footer.role}</span>
          <span>{t.footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
